export const collectionSortNames: SortNames = {
  // RELEVANCE: {
  //   tid: "toolbar.sort.relevance",
  //   value: "RELEVANCE",
  //   query: "RELEVANCE",
  //   order: "ASC",
  // },
  RECEIVED_TIME: {
    tid: "toolbar.sort.receivedTime",
    value: "RECEIVED_TIME",
    query: "RECEIVED_TIME",
    order: "DESC",
    hide: "market-game",
  },
  LISTED_TIME: {
    tid: "toolbar.sort.listed",
    value: "LISTED",
    query: "LISTED_TIME",
    order: "DESC",
  },
  PRICEHIGHLOW: {
    tid: "toolbar.sort.priceHighLow",
    value: "PRICEHIGHLOW",
    query: "PRICE",
    order: "DESC",
  },
  PRICELOWHIGH: {
    tid: "toolbar.sort.priceLowHigh",
    value: "PRICELOWHIGH",
    query: "PRICE",
    order: "ASC",
  },
  LEVELHIGHLOW: {
    tid: "toolbar.sort.levelHighLow",
    value: "LEVELHIGHLOW",
    query: "LEVEL",
    order: "DESC",
  },
  LEVELLOWHIGH: {
    tid: "toolbar.sort.levelLowHigh",
    value: "LEVELLOWHIGH",
    query: "LEVEL",
    order: "ASC",
  },
  NUMBERHIGHLOW: {
    tid: "toolbar.sort.numberHighLow",
    value: "NUMBERHIGHLOW",
    query: "NUMBER",
    order: "DESC",
  },
  NUMBERLOWHIGH: {
    tid: "toolbar.sort.numberLowHigh",
    value: "NUMBERLOWHIGH",
    query: "NUMBER",
    order: "ASC",
  },
};
